import './paramCheckbox.scss';
import Checkbox from '../NCheckbox';

export default class ParamCheckbox extends Checkbox {
	constructor($cell, options) {
		super($cell, options);
	}
}
